const COIN_SERVICE_GETTERS = {
  totalBalance: 'coinService/totalBalance',
}

const COIN_SERVICE_DISPATCHERS = {
  getCoins: 'coinService/GET_COINS',
  getBalances: 'coinService/GET_BALANCES',
  getRatePairs: 'coinService/GET_RATE_PAIRS',
}

export { COIN_SERVICE_GETTERS, COIN_SERVICE_DISPATCHERS }
